







import Vue from 'vue';
import _ from 'lodash';
import { Component } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { Build } from '@/types/build';
import BuildListTile from './BuildListTile.vue';

@Component({
  components: { BuildListTile },
})
export default class PreviousBuilds extends Vue {
  @Mutation('builds/newLiveBuild') newLiveBuild!: Function;
  @Getter('builds/builds') builds!: Build[];
  @Action('builds/getBuilds') getBuilds!: Function;

  created() {
    this.getBuilds();
  }
}
